
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class StockAllocatedItemsGrid extends Serenity.EntityGrid<StockAllocatedItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.StockAllocatedItems'; }
        protected getDialogType() { return StockAllocatedItemsDialog; }
        protected getIdProperty() { return StockAllocatedItemsRow.idProperty; }
        protected getInsertPermission() { return StockAllocatedItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return StockAllocatedItemsRow.localTextPrefix; }
        protected getService() { return StockAllocatedItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        //protected getSlickOptions() {
        //    let opt = super.getSlickOptions();
        //    opt.editable = true;
        //    opt.autoEdit = true;
        //    //opt.forceFitColumns = true;
        //    return opt;
        //}
        
    }
}